import Hero from "@/components/Hero";
import MissionStory from "@/components/MissionStory";
import Manifesto from "@/components/Manifesto";
import Marquee from "@/components/Marquee";
import Archetypes from "@/components/Archetypes";
import FeaturedProducts from "@/components/FeaturedProducts";
import VideoSection from "@/components/VideoSection";
import LeadMagnet from "@/components/LeadMagnet";
import ShopBanner from "@/components/ShopBanner";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <MissionStory />
      <Manifesto />
      <Marquee />
      <Archetypes />
      <FeaturedProducts />
      <VideoSection />
      <LeadMagnet />
      <ShopBanner />
    </main>
  );
}
